import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useMediaQuery } from "_common/component/MediaQueryProvider";
import MobilePassword from "./MobilePassword";
import DesktopPassword from "./DesktopPassword";

const ChangePasswordPage = observer(() => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  if (isMobile) return <MobilePassword />;

  return <DesktopPassword />;
});

export default ChangePasswordPage;
